import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "8d1a9NlcK1FZIwNu4gw7SHd", "SoundManager", undefined);

import { resources, AudioClip, game, Node, director, AudioSource, Game } from "cc";
import { E_GameMode } from "../EnumBase";
import { App } from "./App";
/**
 * 音乐
 */

export var E_MusicType;
/**
 * 音效
 */

(function (E_MusicType) {
  E_MusicType["Hall"] = "Music/bg";
})(E_MusicType || (E_MusicType = {}));

export var E_SoundType;

(function (E_SoundType) {
  E_SoundType["Click"] = "Music/click";
  E_SoundType["BallDie"] = "Music/ballDie";
  E_SoundType["BuySucc"] = "Music/buySucc";
  E_SoundType["CoinGain0"] = "Music/coinGain_0";
  E_SoundType["CoinGain1"] = "Music/coinGain_1";
  E_SoundType["Fail"] = "Music/fail";
  E_SoundType["GainNew"] = "Music/gainNew";
  E_SoundType["NoMoney"] = "Music/noMoney";
  E_SoundType["Win"] = "Music/win";
  E_SoundType["Flower"] = "Music/flower";
})(E_SoundType || (E_SoundType = {}));

var SoundManager = /*#__PURE__*/function () {
  function SoundManager() {
    _defineProperty(this, "_isPlaySound", true);

    _defineProperty(this, "_isPlayMusic", false);

    _defineProperty(this, "_isPlayAD", false);

    _defineProperty(this, "_musicState", false);

    _defineProperty(this, "_effectState", false);

    _defineProperty(this, "_adState", false);

    _defineProperty(this, "_m_as", null);

    _defineProperty(this, "_e_as", null);
  }

  var _proto = SoundManager.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {};

  _proto.start = function start() {};

  _proto.init = function init() {
    var _director$getScene,
        _this = this;

    this._isPlayMusic = App.LocalDBMgr.musicState;
    this._isPlaySound = App.LocalDBMgr.effectState;
    this._musicState = App.LocalDBMgr.musicState;
    var n_audioSource = new Node();
    this._m_as = n_audioSource.addComponent(AudioSource);
    this._e_as = n_audioSource.addComponent(AudioSource);
    (_director$getScene = director.getScene()) === null || _director$getScene === void 0 ? void 0 : _director$getScene.addChild(n_audioSource);
    game.addPersistRootNode(n_audioSource);
    game.on(Game.EVENT_HIDE, function () {
      console.log("EVENT_HIDE");
      game.pause();
      _this.adState = true;
    });
    game.on(Game.EVENT_SHOW, function () {
      console.log("EVENT_SHOW");
      _this.adState = false; // setTimeout(() => {
      //     game.resume();
      // }, 3000);
    });
  }
  /**
   * 播放背景音乐
   * @param path 背景音乐路径
   */
  ;

  _proto.playMusic = function playMusic(path, volume) {
    var _this2 = this;

    if (volume === void 0) {
      volume = 1;
    }

    if (App.GameCtrl.gameMode == E_GameMode.Guide) return; // switch (path) {
    //     case E_MusicType.Hall:
    //         volume = 0.5;
    //     break;
    // }
    // return;

    if (!this._isPlayMusic || this._isPlayAD) {
      return;
    }

    resources.load(path, AudioClip, function (err, ac) {
      if (!err) {
        if (_this2._m_as) {
          _this2._m_as.stop();
        }

        _this2._m_as.clip = ac;
        _this2._m_as.volume = volume;
        _this2._m_as.loop = true;

        _this2._m_as.play();
      } else {
        console.error("load audioClip", err);
      }
    });
  }
  /**
   * 根据类型播放音乐
   * @param type 音乐类型
   */
  ;

  _proto.playMusicType = function playMusicType(type, volume) {
    if (volume === void 0) {
      volume = 1.0;
    }

    this.playMusic(type, volume);
  }
  /**
   * 播放背景音效
   * @param path 背景音效路径
   */
  ;

  _proto.playEffect = function playEffect(path, volume) {
    var _this3 = this;

    if (volume === void 0) {
      volume = 1.0;
    }

    if (App.GameCtrl.gameMode == E_GameMode.Guide) return;

    if (!this._isPlaySound || this._isPlayAD) {
      return;
    }

    resources.load(path, AudioClip, function (err, ac) {
      if (!err) {
        _this3._e_as.playOneShot(ac, volume);
      }
    });
  }
  /**
   * 根据类型播放音效
   * @param type 声音类型
   */
  ;

  _proto.playEffectType = function playEffectType(type, volume) {
    if (volume === void 0) {
      volume = 1.0;
    }

    this.playEffect(type, volume);
  }
  /**音量 - 背景音乐 */
  ;

  _proto.musicVolume = function musicVolume(volume) {
    if (volume === void 0) {
      volume = 1.0;
    }

    this._m_as.volume = volume;
  }
  /**
   * 更新音乐状态
   * @param from 来源
   */
  ;

  _proto.updateMusic = function updateMusic(from) {
    if ((!this._musicState || this._adState) && this._m_as) {
      if (from == "ad") {
        this._m_as.pause();
      } else {
        this._m_as.stop();
      }
    } else {
      if (from == "ad" && this._m_as) {
        this._m_as.play();
      } else {
        this.playMusic(E_MusicType.Hall, 0.5);
      }
    }
  };

  _proto.stopMusic = function stopMusic() {
    if (this._m_as) {
      this._m_as.stop();
    }
  };

  _createClass(SoundManager, [{
    key: "musicState",
    get: function get() {
      return this._musicState;
    },
    set: function set(v) {
      this._musicState = v;
      this.updateMusic("game");
    }
    /**
     * 音效状态
     */

  }, {
    key: "effectState",
    get: function get() {
      return this._effectState;
    },
    set: function set(v) {
      this._effectState = v;
      this._isPlaySound = v;
      this._isPlayMusic = v;
    }
    /**
     * 广告状态
     */

  }, {
    key: "adState",
    get: function get() {
      return this._adState;
    },
    set: function set(v) {
      this._adState = v;
      this.updateMusic("ad");
    }
  }], [{
    key: "I",
    get: function get() {
      if (!SoundManager._I) {
        SoundManager._I = new SoundManager();
      }

      return SoundManager._I;
    } //是否播放声音

  }]);

  return SoundManager;
}();

_defineProperty(SoundManager, "_I", null);

export { SoundManager as default };

_cclegacy._RF.pop();